// ExecDocs (내부문서) — DrivePage 재사용, SECRET 스코프 고정 (루트: data/Secret_docs).
// 백엔드는 /drive API를 scope=SECRET으로 공유. UI 차이는 fixedScope prop 하나뿐이라
// 별도 사본 대신 DrivePage를 그대로 렌더한다 (사본 유지 시 수정 누락 위험).
import DrivePage from "../drive/DrivePage";

export default function ExecDocsPage() {
  return <DrivePage fixedScope="SECRET" />;
}
